import { createFileRoute, useRouter } from "@tanstack/react-router";

import { VerificationAgreementsConnector } from "@pages/verification-agreements";

export const Route = createFileRoute("/_private/policies-agreement")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const toVerification = () => {
    router.navigate({
      search: {
        tab: "verify",
      },
      to: "/profile",
    });
  };

  return (
    <VerificationAgreementsConnector
      variant="policies"
      onGoBack={toVerification}
      onSuccess={toVerification}
    />
  );
}
